import { OnlineIndicator } from "./online-indicator";

export function Layout({
  children,
  footer,
}: {
  children: React.ReactNode;
  footer?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col min-h-screen bg-gray-600 text-white">
      <OnlineIndicator />
      <main className="flex-grow flex flex-col m-4">{children}</main>
      <footer className="bg-gray-700 text-white p-4">{footer}</footer>
    </div>
  );
}
